<template>
    <div>
        <h2>Venue Commissions</h2>
        <CommissionsTable :commissions="venueCommissions" :role="role"/>
        <CommissionForm
            :commissions="venueCommissions"
            :subPlans="subPlans"
            :role="role"
            @commissionCreated="handleCommissionCreated"
        />
    </div>
</template>

<script>
import CommissionsTable from './parts/CommissionsTable.vue'
import CommissionForm from './parts/CommissionForm.vue'

export default {
    components: {
        CommissionsTable,
        CommissionForm,
    },
    data: () => ({
        venueCommissions: [],
        subPlans: [],
        role: 'venue'
    }),
    methods: {
        handleCommissionCreated(newCommission) {
            this.venueCommissions.push(newCommission)
        },
        getVenueSubscription() {
            axios.get('/api/stripe/subscriptions/venue')
                .then(response => {
                    this.subPlans = response.data
                })
                .catch(error => {
                    console.error('Error fetching subscriptions:', error)
                })
        },
        getVenueCommission() {
            axios.get('/admin/get-commission/venue')
                .then(response => {
                    this.venueCommissions = response.data.data
                })
                .catch(error => {
                    console.error('Error fetching venue commissions:', error)
                });
        }
    },
    async mounted() {
        await this.getVenueSubscription()
        await this.getVenueCommission()
    }
}
</script>
